@if (currentDialog === currentDialogEnum.CloudStorageDlg) {
  <asg-cloud-storage-dialog (okPressed)="ok()" (cancelPressed)="no()"></asg-cloud-storage-dialog>
}
@if (currentDialog === currentDialogEnum.FileMoveDlg) {
  <asg-file-move-dialog></asg-file-move-dialog>
}
